import React from "react";
import Footer from "@/Components/Footer";
import Navigation from "@/Components/Navigation";
import FAB from "@/Components/FAB";

export default function Default({ children }) {
    return (
        <div>
            <div className="sticky top-0 z-50">
                <Navigation />
            </div>
            {children}
            <Footer />
            {/* <FAB /> */}
        </div>
    );
}
